import { BullhornNamespace, InveniasNamespace, SalesforceNamespace } from 'datasource-service-lib';
import { InveniasMockNamespace } from 'datasource-service-lib';
import { BullhornMergeBasketViewConfig } from '../services/bullhorn/bullhorn.mergebasketviewconfig';
import { InveniasMergeBasketViewConfig } from '../services/invenias/invenias.mergebasketviewconfig';
import { SalesforceMergeBasketViewConfig } from '../services/salesforce/salesforce.mergebasketviewconfig';
import { ServiceProviderService } from '../services/service.provider.service';
import { IMergeBasketViewConfig } from './merge-basket-view.component';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';

export class MergeBasketViewConfigFactory {
  static create(
    namespace: string,
    serviceProviderService: ServiceProviderService,
    sharedServiceProvider: SharedServiceProviderServiceFactory
  ): IMergeBasketViewConfig {
    if (namespace === InveniasNamespace.name || namespace === InveniasMockNamespace.name) {
      return new InveniasMergeBasketViewConfig(serviceProviderService, sharedServiceProvider);
    }

    if (namespace === BullhornNamespace.name) {
      return new BullhornMergeBasketViewConfig(serviceProviderService, sharedServiceProvider);
    }

    if (namespace === SalesforceNamespace.name) {
      return new SalesforceMergeBasketViewConfig(serviceProviderService, sharedServiceProvider);
    }

    throw new Error(`Cannot find config for namespace '${namespace}'.`);
  }
}
